<template>
  <el-dialog
    :title="ruleForm.paperName+'——考题组成信息'"
    :visible.sync="visible"
    width="560px"
    append-to-body
    :close-on-press-escape="false"
    @closed="handleClosed">
    <el-table
      border
      :summary-method="getSummaries"
      show-summary
      :data="ruleForm.questionCombinations">
      <el-table-column
        prop="questionType"
        label="题型"
        min-width="100">
        <template slot-scope="{ row }">{{ row.questionType | questionTypeName() }}</template>
      </el-table-column>
      <el-table-column
        prop="questionDifficulty"
        label="难度"
        min-width="80">
        <template slot-scope="{ row }">{{ row.questionDifficulty | questionDifficultyName() }}</template>
      </el-table-column>
      <el-table-column
        prop="questionCount"
        label="考题数量"
        min-width="80">
      </el-table-column>
      <el-table-column
        prop="questionPerScore"
        label="考题分值"
        min-width="80">
      </el-table-column>
    </el-table>
    <span slot="footer">
      <el-button
        @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'ExaminationPaperInfoModal',
  data() {
    return {
      visible: false,
      ruleForm: { paperName: '', questionCombinations: [] }
    }
  },
  computed: {
    paperScore({ ruleForm }) {
      let paperScore = 0
      let questionCount = 0
      ruleForm.questionCombinations.forEach(i => {
        paperScore += (i.questionCount || 0) * (i.questionPerScore || 0)
        questionCount += i.questionCount || 0
      })
      return ['考卷总分：', paperScore + '分', questionCount, '-']
    }
  },
  methods: {
    getSummaries() {
      return this.paperScore
    },
    handleClosed() {
      this.ruleForm = { ...this.ruleForm, ...this.$options.data().ruleForm }
      setTimeout(() => {
        this.$refs.ruleForm && this.$refs.ruleForm.clearValidate()
      }, 20)
    },
    init(options = {}) {
      this.ruleForm = { ...this.ruleForm, ...options }
      this.visible = true
    }
  }
}
</script>
<style lang="stylus" scoped>
  /deep/.el-table__footer-wrapper{
    td {
      font-size: 13px
    }
    td:first-child {
      font-weight: bold;
    }
    td:nth-child(2) {
      font-weight: bold;
      color: red
    }
  }
</style>
